import React from "react";
import { SvgIcon, useTheme } from "@material-ui/core";

const TagsManagementIcon = (props) => {
  const theme = useTheme();
  const secondaryColor = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      {/* Outer container */}
      <rect x="4" y="4" width="40" height="40" rx="8" fill="currentColor" />

      {/* Tag 1 */}
      <path d="M12 16L20 10L28 18L20 24L12 16Z" fill="white" />

      {/* Tag hole */}
      <circle cx="20" cy="16" r="1.5" fill="currentColor" />

      {/* Tag 2 (slightly offset for layering effect) */}
      <path d="M16 26L24 20L32 28L24 34L16 26Z" fill="white" />

      {/* Tag hole */}
      <circle cx="24" cy="26" r="1.5" fill="currentColor" />

      {/* Settings badge */}
      <circle
        cx="36"
        cy="36"
        r="6"
        fill={props.disableFill ? "" : secondaryColor}
      />

      {/* Simple gear (minimal, non-blurry) */}
      <path
        d="M36 33.5L37 34L38.5 33.5L39 35L38.5 36L39 37.5L37.5 38L36.5 37.5L35.5 38L34 37.5L34.5 36L34 35L35.5 34L36 33.5Z"
        fill="white"
      />

      {/* Gear center */}
      <circle cx="36" cy="36" r="1.2" fill={secondaryColor} />
    </SvgIcon>
  );
};

export default TagsManagementIcon;
